import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription, tap } from 'rxjs';
import { ModalDrawService } from '../modal-draw.service';
import { VisorgisService } from '../../../services/visorgis.service';

import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-draw-toma',
  templateUrl: './draw-toma.component.html',
  styleUrls: ['./draw-toma.component.css'],
  imports: [IonicModule, FormsModule, ReactiveFormsModule],
})
export class DrawTomaComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() att: any;
  values: any[] = [];
  searchTerm: string;
  selectedValue: string;
  hidrantes: any[] = [];
  formSubscription: Subscription[] = [];
  @Output() onSubmitComplete: EventEmitter<any> = new EventEmitter<any>();

  myForm = this.fb.group({
    hidrante_id: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private modalService: ModalDrawService,
    private visorgisServ: VisorgisService
  ) {}

  ngOnInit(): void {
    this.formSubscription.push(
      this.myForm.statusChanges
        .pipe(
          tap(res => {
            this.modalService.formularioValido(res == 'VALID');
          })
        )
        .subscribe()
    );
    this.formSubscription.push(
      this.visorgisServ
        .getListadoHidrantes()
        .pipe(
          tap(res => {
            console.log('HIDRANTES', res);
            this.hidrantes = res.hydrants;
            if (this.att) {
              console.log(this.att);
              let h_id;
              try {
                h_id = this.att.hidrante_id.split('(')[1].split(',')[0];
              } catch {
                h_id = this.att.hidrante_id;
              }
              console.log(h_id);

              console.log(this.att);
              this.myForm.controls['hidrante_id'].setValue(h_id);
              // this.myForm.patchValue({
              //   hidrante_id: h_id
              // })
            }
          })
        )
        .subscribe()
    );
    this.formSubscription.push(
      this.modalService.confirmButton
        .pipe(
          tap(res => {
            this.onSubmit(res);
          })
        )
        .subscribe()
    );
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.formSubscription.forEach(s => s.unsubscribe());
  }

  onSubmit(geojson) {
    if (this.att) {
      this.att.hidrante_id = this.myForm.controls['hidrante_id'].value;
      this.visorgisServ
        .editTomaById(this.att)
        .pipe(
          tap(res => {
            console.log(res);
            this.onSubmitComplete.emit(res);
          })
        )
        .subscribe();
    } else {
      geojson.properties.name = '';
      geojson.properties.hidrante_id =
        this.myForm.controls['hidrante_id'].value;
      console.log(geojson);
      this.visorgisServ
        .createToma(geojson)
        .pipe(
          tap(res => {
            console.log(res);
            this.onSubmitComplete.emit(res);
          })
        )
        .subscribe();
    }
  }

  onSearchChange(event) {
    console.log(event);
  }

  compareWith(o1, o2) {
    return parseInt(o1) == o2;
  }

  handleChange(ev) {
    console.log(ev.target.value);
    this.myForm.controls['hidrante_id'].setValue(ev.target.value);
  }
}
